import { Component, computed, input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MDIconComponent } from '@melodic-ui/components';

@Component({
	selector: 'lb-invoice-action-cell',
	standalone: true,
	templateUrl: './invoice-action-cell.component.html',
	styleUrls: ['./invoice-action-cell.component.scss'],
	imports: [MDIconComponent, RouterModule]
})
export class InvoiceActionCellComponent {
	invoiceID = input.required<number>();
	isAdmin = input.required<boolean>();

	icon = computed(() => {
		return this.isAdmin() ? 'untitled-ui/general/edit-05' : 'untitled-ui/charts/bar-chart-square-01';
	});
}
